import { AppLayout } from "@/components/layout/app-layout";
import { PageHeader } from "@/components/layout/page-header";
import { TransactionsTabs } from "@/components/transactions/transactions-tabs";
import { useMemo } from "react";
import { useAuth } from "@/contexts/auth-context";

const Transactions = () => {
  const { organization } = useAuth();

  const organizationName = organization?.name ?? "Swiss Finance OS";

  const periodLabel = useMemo(() => {
    const now = new Date();
    const quarter = Math.floor(now.getMonth() / 3) + 1;
    return `Q${quarter} ${now.getFullYear()}`;
  }, []);

  return (
    <AppLayout>
      <PageHeader
        title="Transaktionen"
        subtitle={`${organizationName} • ${periodLabel}`}
        showMandateBadge
      />
      
      <main className="flex-1 p-page-padding lg:p-page-padding-lg overflow-auto">
        <TransactionsTabs />
      </main>
    </AppLayout>
  );
};

export default Transactions;